import { companyType } from '../D2r';
import { Retailer } from './Retailer';

export const Retailers = ({ company }: { company: companyType }) => <Retailer company={company} />;
